'use client'

import Search from '../../icons/Search'
import { cn } from '../../utils/cn'
import { Input } from '../_base/Input'

type SearchInputProps = React.ComponentProps<typeof Input>

export function SearchInput({ className, size, ...props }: SearchInputProps) {
  'use memo'

  return (
    <div className="relative">
      <Search
        className={cn(
          'text-muted-foreground absolute top-1/2 left-3 -translate-y-1/2',
          size === 'sm' ? 'size-3.5' : 'size-4'
        )}
        aria-hidden="true"
      />
      <Input
        type="search"
        placeholder="Search"
        size={size}
        className={cn(
          '[&::-webkit-search-cancel-button]:cursor-pointer [&::-webkit-search-cancel-button]:ml-2 [&::-webkit-search-cancel-button]:opacity-100 [&::-webkit-search-cancel-button]:transition-opacity [&:hover::-webkit-search-cancel-button]:opacity-70',
          size === 'sm' ? 'pl-8' : 'pl-9',
          className
        )}
        {...props}
      />
    </div>
  )
}
